import { jsx as _jsx } from "react/jsx-runtime";
import { useLocalizeMessage, Text } from 'libs.nucleus';
import { useDateTime } from 'libs.react';
import { stepResponseTypes } from '../../constants/step_response_type.constants';
import { escapeNonBreakingSpaces } from '../../helpers/ecoa.format.helpers';
import { isEventListData, renderEventListDisplay, processStepResponseWithEventList, resolveEventListLabels, } from '../../helpers/step_response_variable.helpers';
export const StepResponseValue = ({ stepResponse, variables }) => {
    const translate = useLocalizeMessage();
    const dateFormatter = useDateTime();
    if (stepResponse?.c_skipped) {
        return _jsx(Text, { children: translate('generic.skipped') });
    }
    //  For image captures where an image is uploaded
    if (stepResponse.type === stepResponseTypes?.cImageCapture.objectType) {
        return (_jsx("img", { alt: stepResponse.c_step.c_name ?? 'Image', "data-testid": `step-response-${stepResponse._id}`, src: stepResponse?.url }));
    }
    //  For Date time formatting
    if (stepResponse.type === stepResponseTypes?.cDatetime.objectType) {
        return _jsx(Text, { children: dateFormatter.parseDateTimeShort(stepResponse.c_value) });
    }
    //  Date formatting
    if (stepResponse.type === stepResponseTypes?.cDate.objectType) {
        return (_jsx(Text, { children: dateFormatter.parseDateShort(stepResponse.c_value, {
                timeZone: 'UTC',
            }) }));
    }
    //  Text choice formatting (with dynamic c_text_choices from event list variables)
    if (stepResponse.type === stepResponseTypes?.cTextChoice.objectType) {
        if (variables && Array.isArray(stepResponse.c_value)) {
            const resolvedLabels = resolveEventListLabels(stepResponse.c_value, variables);
            if (resolvedLabels) {
                return _jsx(Text, { children: resolvedLabels });
            }
        }
        // Process step response only when needed for text choices
        const processedStepResponse = variables ? processStepResponseWithEventList(stepResponse, variables) : stepResponse;
        const textChoices = (processedStepResponse?.c_step?.c_text_choices || []).filter((textChoice) => {
            if (Array.isArray(processedStepResponse.c_value)) {
                return processedStepResponse.c_value.includes(textChoice.c_value);
            }
            return textChoice.c_value?.toString() === processedStepResponse.c_value?.toString();
        });
        return _jsx(Text, { children: textChoices.map((textChoice) => escapeNonBreakingSpaces(textChoice.c_text)).join(', ') });
    }
    //  Event list variable formatting
    if (isEventListData(stepResponse.c_value)) {
        try {
            const displayText = renderEventListDisplay(stepResponse.c_value);
            if (displayText) {
                return (_jsx("div", { style: { whiteSpace: 'pre-line' }, children: _jsx(Text, { children: displayText }) }));
            }
        }
        catch (error) {
            console.warn('Failed to process event list variable:', error);
        }
    }
    return _jsx(Text, { children: stepResponse.c_value });
};
export default StepResponseValue;
